var _ = require('lodash')
import { sendError } from '@/service/http.js'
import store from '@/store'

export function sendErrorLog(error) {
  sendError(store.state.user.id, String(error))
}

/**
 * 生成UUID
 */
export function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0
        var v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

/**
 * 截取字符串
 */
export function splitWords(val, limit) {
    if (val && limit > 0 && val.length > limit) {
        return val.slice(0, limit)
    } else {
        return val
    }
}

/**
 * 校验手机号码
 */
export function isPhone(phone) {
    return /^1(3\d|4\d|5\d|6\d|7\d|8\d|9\d)\d{8}$/g.test(phone)
}

/**
 * 除去多余的空格和收尾空格
 */
export function resetBlank(val) {
    var regEx = /\s+/g
    var s = val.replace(regEx, ' ')
    return s.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * 校验钱包地址是否合法
 * @param {Object} val
 */
export function volidAddress(val) {
    if (_.isEmpty(val)) return false
    const x = val.indexOf(':')
    if (x > 0) {
        const unit = process.env.chain_unit_lower
        const tempAddress = unit + ':' + 'SZBdKXXMLd1op4zmenF6pPCNR3RWDwBvEc'
        const baseLenght = tempAddress.length
        if (val.length != baseLenght) {
            return false
        }
        const coin = val.split(':')[0]
        if (unit != coin.toLocaleLowerCase()) {
            return false
        }
        return val.split(':')[1]
    } else {
        const tempAddress = 'SZBdKXXMLd1op4zmenF6pPCNR3RWDwBvEc'
        if (val.length != tempAddress.length) {
            return false
        } else {
            return val
        }
    }
}


export function toPoint(percent){
  var str=percent.replace('%','')
  str= str/100
  return str
}

//小数转百分比
export function toPercent(point){
  console.log('小数：',point)
  var str=(Number(point)*100).toFixed(2)
  str+='%'
  return str
}



// WEBPACK FOOTER //
// ./src/utils/common.js